// extracted by mini-css-extract-plugin
export var resizer = "_fw-0";